<form class="f-col blank-form" [formGroup]="personalinfoForm">
    <div class="section-heading">
        <h2 class="h2-heading">{{content?.['b2b.managetraveler.personalinfo']}}</h2>
        <a tabindex="0" role="button" class="link" (click)="Editpersonal()"
            *ngIf="userId && guid && Loader.isEditableClicked && isTAEditMode"><mat-icon fontSet="material-symbols-outlined"
                class="edit-icon">edit</mat-icon>{{content?.['b2b.managetraveler.edit']}} </a>
    </div>

    <div class="section-content" [class.view-disabled]="Loader.isEditableClicked">
        <div class="inner-contentsection">
            <div class="f-row two--ColLayout passenger-title-input">
                <div class="f-col control-wrapper" [class.view-disabled]="isElmVerified">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managetraveler.title']}}</mat-label>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix
                            class="mat-select">stat_minus_1</mat-icon>
                        <mat-select formControlName="title" data-dd-privacy="mask">
                            <mat-option [value]="title.Phrase"
                                *ngFor="let title of titles">{{title.Phrase}}</mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="personalinfoForm.get('title')?.hasError('required') && personalinfoForm.get('title')?.touched">
                            {{content?.dictionary?.['b2b.managetraveler.titlerequired']}} </mat-error>
                        <mat-error
                            *ngIf="personalinfoForm.get('title')?.hasError('minlength') && personalinfoForm.get('title')?.touched">
                            {{content?.dictionary?.['b2b.managetraveler.title2char']}} </mat-error>
                        <mat-error
                            *ngIf="personalinfoForm.get('title')?.hasError('maxlength') && personalinfoForm.get('title')?.touched">
                            {{content?.dictionary?.['b2b.managetraveler.title5char']}} </mat-error>
                    </mat-form-field>
                </div>
                <div class="f-col control-wrapper" [class.view-disabled]="isElmVerified">
                    <mat-form-field appearance="fill">
                        <mat-label>{{content?.['b2b.managetraveler.firstname']}}</mat-label>
                        <input matInput formControlName="userFirstName" autocomplete="off"
                            (keypress)="onKeyPress($event)" (paste)="_CommonService.onPasteBlocked($event)"
                            (contextmenu)="_CommonService.disableRightClick($event)"
                            (input)="onFieldStatusChange({isFilled: true, field: 'userFirstName', value: 'name', isValid :true })"
                            data-dd-privacy="mask">
                        <mat-error
                            *ngIf="personalinfoForm.get('userFirstName')?.hasError('required') && personalinfoForm.get('userFirstName')?.touched">
                            {{content?.dictionary?.['b2b.managetraveler.firstnamerequired']}} </mat-error>
                        <mat-error
                            *ngIf="personalinfoForm.get('userFirstName')?.hasError('minlength') && personalinfoForm.get('userFirstName')?.touched">
                            {{content?.dictionary?.['b2b.managetraveler.firstname2char']}} </mat-error>
                        <mat-error
                            *ngIf="personalinfoForm.get('userFirstName')?.hasError('maxlength') && personalinfoForm.get('userFirstName')?.touched">
                            {{content?.dictionary?.['b2b.managetraveler.firstname50char']}} </mat-error>
                        <mat-error
                            *ngIf="personalinfoForm.get('userFirstName')?.hasError('noHtmlTagsValidator') && personalinfoForm.get('userFirstName')?.touched">
                            {{content?.dictionary?.['b2b.managetraveler.firstnamespclchar']}} </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="f-row two--ColLayout">

                <div class="f-col" [class.view-disabled]="isElmVerified">
                    <mat-form-field appearance="fill">
                        <mat-label>{{content?.['b2b.managetraveler.lastname']}}</mat-label>
                        <input matInput formControlName="userLastName" autocomplete="off"
                            (keypress)="_CommonService.allowOnlyCharacters($event)"
                            (paste)="_CommonService.onPasteBlocked($event)"
                            (contextmenu)="_CommonService.disableRightClick($event)"
                            data-dd-privacy="mask">
                        <mat-error
                            *ngIf="personalinfoForm.get('userLastName')?.hasError('required') && personalinfoForm.get('userLastName')?.touched">
                            {{content?.dictionary?.['b2b.managetraveler.lastnamerequired']}} </mat-error>
                        <mat-error
                            *ngIf="personalinfoForm.get('userLastName')?.hasError('minlength') && personalinfoForm.get('userLastName')?.touched">
                            {{content?.dictionary?.['b2b.managetraveler.lastname2char']}} </mat-error>
                        <mat-error
                            *ngIf="personalinfoForm.get('userLastName')?.hasError('maxlength') && personalinfoForm.get('userLastName')?.touched">
                            {{content?.dictionary?.['b2b.managetraveler.lastname50char']}} </mat-error>
                        <mat-error
                            *ngIf="personalinfoForm.get('userLastName')?.hasError('noHtmlTagsValidator') && personalinfoForm.get('userLastName')?.touched">
                            {{content?.dictionary?.['b2b.managetraveler.lastnamespclchar']}} </mat-error>
                    </mat-form-field>
                </div>
                <div class="f-col position-relative" [class.view-disabled]="isElmVerified">
                    <mat-form-field appearance="fill" (click)="showComponent('isDOBCalendarVisible','userDOB')">
                        <mat-label>{{content?.['b2b.managetraveler.dateofbirth']}}</mat-label>
                        <input matInput formControlName="userDOB" placeholder="Select your date of birth"
                            autocomplete="off" (keypress)="_CommonService.blockInvalidCharactersForDOB($event)"
                            (blur)="isDOBInvalid('ADT')" (paste)="_CommonService.pasteControlHTMLTags($event)"
                            readonly data-dd-privacy="mask" />
                        <mat-icon fontSet="material-symbols-outlined" matSuffix>calendar_today</mat-icon>
                        <mat-error
                            *ngIf="personalinfoForm.get('userDOB')?.hasError('required') && personalinfoForm.get('userDOB')?.touched">
                            {{content?.dictionary?.['b2b.managetraveler.selectdob']}} </mat-error>
                        <mat-error
                            *ngIf="personalinfoForm.get('userDOB')?.hasError('validADT') && personalinfoForm.get('userDOB')?.touched">Traveller
                            {{content?.dictionary?.['b2b.managetraveler.age12years']}}</mat-error>

                    </mat-form-field>
                    <app-date-ofbirth *ngIf="isChildVisible['isDOBCalendarVisible']" [disabled]="isDisableDateOfBirth"
                        (confirm)="onConfirm('isDOBCalendarVisible')" (dateSelected)="onDateSelected($event)"
                        [PassengerTypeCode]="'ADT'" class="datepicker-content-container" data-dd-privacy="mask"> </app-date-ofbirth>
                </div>
            </div>

            <div class="f-row">
                <div class="f-col" [class.view-disabled]="isElmVerified">
                    <div class="f-row validation-col radio-group-container">
                        <label class="mat-label" for="Gender">{{content?.['b2b.managetraveler.gender']}}</label>
                        <mat-radio-group id="gender" formControlName="gender" aria-label="Select a gender" data-dd-privacy="mask">
                            <mat-radio-button value="Male">{{content?.['b2b.managetraveler.male']}}</mat-radio-button>
                            <mat-radio-button
                                value="Female">{{content?.['b2b.managetraveler.female']}}</mat-radio-button>
                        </mat-radio-group>
                        <mat-error
                            *ngIf="personalinfoForm.get('gender')?.hasError('required') && personalinfoForm.get('gender')?.touched">
                            {{content?.dictionary?.['b2b.managetraveler.selectgender']}} </mat-error>
                    </div>
                </div>
            </div>
            <div class="f-row two--ColLayout">
                <div class="f-col" [class.view-disabled]="!canEditEmployeeCode">
                    <mat-form-field appearance="fill">
                        <mat-label>{{content?.['b2b.managetraveler.employcode']}}</mat-label>
                        <input matInput formControlName="employeeCode" autocomplete="off"
                            (keypress)="onKeyPressCompCode($event)" (paste)="_CommonService.onPasteBlocked($event)"
                            (contextmenu)="_CommonService.disableRightClick($event)" data-dd-privacy="mask" />
                        <mat-error
                            *ngIf="personalinfoForm.get('employeeCode')?.hasError('maxlength') && personalinfoForm.get('employeeCode')?.touched">
                            {{content?.dictionary?.['b2b.managetraveler.employeecode25char']}} </mat-error>
                        <mat-error
                            *ngIf="personalinfoForm.get('employeeCode')?.hasError('required')">{{content?.dictionary?.['b2b.register.employeecodereq']}}
                        </mat-error>
                        <mat-error *ngIf="personalinfoForm.get('employeeCode')?.hasError('duplicate')">
                            Employee code already exists.
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="f-col">
                    <mat-form-field>
                        <mat-label> {{content?.['b2b.managetraveler.emailaddress']}}</mat-label>
                        <input matInput formControlName="emailAddress" placeholder="Enter your email address"
                            (keypress)="_CommonService.blockInvalidCharacters($event)"
                            (paste)="_CommonService.onPasteBlocked($event)"
                            (contextmenu)="_CommonService.disableRightClick($event)" (blur)="checkEmailExist()"
                            data-dd-privacy="mask">
                        <mat-icon fontSet="material-symbols-outlined" matSuffix>mail</mat-icon>
                        <mat-error
                            *ngIf="personalinfoForm.get('emailAddress')?.hasError('required') && personalinfoForm.get('emailAddress')?.touched">
                            {{content?.dictionary?.['b2b.managetraveler.emailrequired']}} </mat-error>
                        <mat-error
                            *ngIf="personalinfoForm.get('emailAddress')?.hasError('email') && personalinfoForm.get('emailAddress')?.touched">
                            {{content?.dictionary?.['b2b.managetraveler.entervalidemail']}} </mat-error>
                        <mat-error *ngIf="personalinfoForm.get('emailAddress')?.hasError('isExist')">
                            {{content?.dictionary?.['b2b.managecompany.emailalreadyexists'] || 'Email already exists'}}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="f-row two--ColLayout">
                <div class="f-col">
                    <ng-select autoBlurSelect [items]="countriesLists" groupBy="group"
                        [searchFn]="_CommonService.customCountryCodeSearchFn" formControlName="countryCode"
                        bindValue="code" [placeholder]="content?.['b2b.managetraveler.countrycode']"
                        [appendTo]="'body'" data-dd-privacy="mask">
                        <ng-template ng-optgroup-tmp let-item="item"> {{ item.group }}
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item">
                            <span class="ng-option-label">
                                <ng-container *ngIf="!!item?.newFlag?.src">
                                    <img [src]="getImageUrl(item?.newFlag?.src)" alt="Flag of {{ item.countryName }}"
                                        class="flag-img" [height]="item.height" [width]="item.width" />
                                </ng-container>
                                {{ item.countryName }} ({{ item?.code }})
                            </span>
                        </ng-template>
                        <ng-template ng-label-tmp let-item="item">
                            <span class="ng-value-label">
                                <span class="ng-disabled" *ngIf="item?.code">{{ item?.code }}</span></span>
                        </ng-template>
                        <ng-template ng-notfound-tmp>
                            <div class="no-items-found">
                                <img src="assets/images/not-found.png" alt="No items found" class="no-items-image" />
                                <p>{{content?.dictionary?.['b2b.managetraveler.nocountryfound']}}</p>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="f-col">
                    <mat-form-field appearance="fill">
                        <mat-label>{{content?.['b2b.managetraveler.mobileno']}}</mat-label>
                        <!-- (blur)="checkMobileNumberExist()" -->
                        <input matInput formControlName="phoneNumber" placeholder="Enter your phone number"
                            (keypress)="blockInvalidCharacters($event)" (paste)="_CommonService.onPasteBlocked($event)"
                            (contextmenu)="_CommonService.disableRightClick($event)"
                            data-dd-privacy="mask">
                        <mat-icon fontSet="material-symbols-outlined" matSuffix>phone_android</mat-icon>
                        <mat-error
                            *ngIf="personalinfoForm.get('phoneNumber')?.hasError('required') && personalinfoForm.get('phoneNumber')?.touched">
                            {{content?.dictionary?.['b2b.register.mobilereq']}} </mat-error>

                        <mat-error
                            *ngIf="personalinfoForm.get('phoneNumber')?.hasError('minlength') && personalinfoForm.get('phoneNumber')?.touched">
                            {{content?.dictionary?.['b2b.managecompany.cannotexceedmobilenumber']}}
                        </mat-error>

                        <mat-error
                            *ngIf="personalinfoForm.get('phoneNumber')?.hasError('maxlength') && personalinfoForm.get('phoneNumber')?.touched">
                            {{content?.dictionary?.['b2b.managecompany.cannotexceedmobilenumber']}}
                        </mat-error>

                        <!-- <mat-error
                            *ngIf="personalinfoForm.get('phoneNumber')?.hasError('pattern') && personalinfoForm.get('phoneNumber')?.touched">
                            {{content?.dictionary?.['b2b.register.10digitmobile'] || 'Mobile number must be 10 digits.'}}
                        </mat-error> -->

                        <mat-error *ngIf="personalinfoForm.get('phoneNumber')?.hasError('mobileExist')">
                            {{content?.['"b2b.managetraveler.phonenoexists'] || 'Phone number already exists.'}}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>


            <div class="f-row two--ColLayout">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>AlFursan Number</mat-label>
                        <input matInput formControlName="alfursanID"
                            (keypress)="_CommonService.blockInvalidCharacters($event)"
                            (paste)="_CommonService.onPasteBlocked($event)"
                            (contextmenu)="_CommonService.disableRightClick($event)"
                            data-dd-privacy="mask">

                        <mat-error
                            *ngIf="personalinfoForm.get('alfursanID')?.touched || personalinfoForm.get('alfursanID')?.dirty">

                            <!-- Number length error -->
                            <span *ngIf="personalinfoForm.get('alfursanID')?.hasError('invalidNumberLength')">
                                AlFursanId must be exactly 10 digits.
                            </span>

                            <!-- Email max length -->
                            <span *ngIf="personalinfoForm.get('alfursanID')?.hasError('emailMaxLength')">
                                Email must not exceed 200 characters.
                            </span>

                            <!-- Pattern error -->
                            <span *ngIf="personalinfoForm.get('alfursanID')?.hasError('pattern')">
                                {{content?.['b2b.managetraveler.efalfursanid']?.split('/')[0] }} 10 digit or email allowed only.
                            </span>

                            <!-- Pattern error -->
                            <span *ngIf="personalinfoForm.get('alfursanID')?.hasError('invalidAlfursan')">
                                Invalid AlFursan id.
                            </span>

                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

        </div>

        <div class="inner-contentsection">
            <h4 class="subheading">{{content?.['b2b.managetraveler.userrights']}}
            </h4>
            <div class="f-row">
                <div class="f-col">
                    <div class="f-row validation-col radio-group-container">
                        <label class="mat-label"
                            for="IsCorpTravelArranger">{{content?.['b2b.managetraveler.usertype']}}</label>
                        <mat-radio-group id="IsCorpTravelArranger" formControlName="IsCorpTravelArranger" aria-label="Select an option">
                            <ng-container *ngIf="loggedInUserType === 0; else restrictedRoles">
                                <mat-radio-button [value]="0">{{content?.['b2b.managetraveler.administrator']}}</mat-radio-button>
                                <mat-radio-button [value]="1">{{content?.['b2b.managetraveler.travelarranger']}}</mat-radio-button>
                                <mat-radio-button [value]="2">{{content?.['b2b.managetraveler.employee']}}</mat-radio-button>
                            </ng-container>
                            <ng-template #restrictedRoles>
                                <mat-radio-button [value]="0" *ngIf="editedUserType === 0">{{content?.['b2b.managetraveler.administrator']}}</mat-radio-button>
                                <mat-radio-button [value]="1" *ngIf="editedUserType === 1"> {{content?.['b2b.managetraveler.travelarranger']}}</mat-radio-button>
                                <mat-radio-button [value]="2"*ngIf="editedUserType === 2">{{content?.['b2b.managetraveler.employee']}}</mat-radio-button>
                        </ng-template>
                    </mat-radio-group>
                        <mat-error
                            *ngIf="personalinfoForm.get('IsCorpTravelArranger')?.hasError('required') && personalinfoForm.get('IsCorpTravelArranger')?.touched">
                            {{content?.dictionary?.['b2b.managetraveler.selectusertype']}} </mat-error>
                    </div>
                </div>
            </div>
            <div class="f-row" *ngIf="personalinfoForm.value.IsCorpTravelArranger === 0 && showUserRights">
                <div class="f-col">
                    <div class="f-row validation-col radio-group-container">
                        <label class="mat-label">{{content?.['b2b.managetraveler.rights']}}</label>
                        <div class="f-row mat-check-group">
                            <mat-checkbox formControlName="isEmpRightsForTrip"
                                class="checkbox-wrapper">{{content?.['b2b.managetraveler.proceedcheckout']}}</mat-checkbox>
                            <mat-checkbox formControlName="allowUserLiveAccess"
                                class="checkbox-wrapper">{{content?.['b2b.managetraveler.blockuseraccess']}}</mat-checkbox>
                        </div>
                    </div>
                </div>
            </div>

        </div>


        <div class="inner-contentsection">

            <div class="f-col mat-check-group">


                <mat-checkbox class="checkbox-wrapper"
                    formControlName="cocnsentTC">{{content?.['b2b.managetraveler.efaccepttermscheckbox']?.replace('Terms
                    of Use.','')}}
                    <a target="_blank" rel="noopener noreferrer"
                        href="https://www.saudia.com/en-SA/information/terms-and-conditions/terms-of-use?sc_lang=en&sc_country=SA">Terms
                        of Use</a>.
                </mat-checkbox>

                <mat-checkbox class="checkbox-wrapper"
                    formControlName="consentTCPP">{{content?.['b2b.managetraveler.efprivacypolicycheckbox']?.replace('Terms
                    of Use and Privacy Policy.','')}}
                    <a target="_blank" rel="noopener noreferrer"
                        href="https://www.saudia.com/en-SA/information/terms-and-conditions/terms-of-use?sc_lang=en&sc_country=SA">Terms
                        of Use</a> and
                    <a target="_blank" rel="noopener noreferrer"
                        href="https://www.saudia.com/en-IN/information/terms-and-conditions/privacy-policy">Privacy
                        Policy</a>.
                </mat-checkbox>

                <mat-checkbox class="checkbox-wrapper" formControlName="ConsentMarketing">
                    {{convertText(content?.['b2b.managetraveler.efreceiveoffercheckbox']).p1}}
                    <span class="m-top-8x"> {{convertText(content?.['b2b.managetraveler.efreceiveoffercheckbox']).p2}}
                    </span>
                </mat-checkbox>
            </div>
        </div>
        <div class="inner-action" *ngIf="!Loader.isEditableClicked">
            <button mat-button type="button" class="button--secondary-small" [class.disabled]="Loader.isEditableClicked"
                [disabled]="Loader.isEditableClicked "
                (click)="Cancel()">{{content?.['b2b.managetraveler.cancel']}}</button>
            <button mat-button type="button" class="button--primary-small" (click)="onSave()"
                [disabled]="personalinfoForm.invalid || !hasFormChanges "
                [class.disabled]="personalinfoForm.invalid || !hasFormChanges || Loader.isSpinner">
                <mat-spinner diameter="20" class="button" *ngIf="Loader.isSpinner"></mat-spinner>
                {{content?.['b2b.managetraveler.save']}}</button>
        </div>
    </div>
</form>